//------------- REACT IMPORT ---------------//
import React, { useState } from "react";
import { Button, Col, Container, Image, Row } from "react-bootstrap";
//---------- FONTAWESOME IMPORT ------------//
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faAlternateCalendar, faBed, faCakeCandles, faCalendarMinus, faCalendarWeek, faHouse, faPlus, faVenus
} from "@fortawesome/free-solid-svg-icons";
//-------- BOOTSTRAP ITEMS IMPORT ----------//
//import { Button, Col, Container, Image, Row } from "react-bootstrap";
import * as Constants from "../../../Helper/constants/constants";
import WithoutImageHeader from "../../../Helper/withoutImageHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomTab from "../../../Helper/customTabs";
import Task from "../../Tabs/Task";
import { Filter, LogCalendar } from "../../../../assets/images";
import PaginationComponent from "../../CommanComponents/Pagination";
import Datepicker from "../../../Helper/datepicker";
import CustomDatepicker from "../../../Helper/customDatePicker";
import CalendarModal from "../../Modals/CalendarModal";
import FilterModal from "../../Modals/FilterModal";

const MyTasks = () => {
    const [currentTab, setCurrentTab] = useState('1');
    const [showCalendarModal, setShowCalendarModal] = useState(false);
    const [showFilterModal, setShowFilterModal] = useState(false);
    const tabs = [
        {
            id: 1,
            tabTitle: 'All',
        },
        {
            id: 2,
            tabTitle: 'Assigned to me',
        },
        {
            id: 3,
            tabTitle: 'Assigned by me',
        }
    ];

    return (
        <div className="task_section">
            <WithoutImageHeader header={Constants.MY_TASKS_DETAIL} />
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="task_area">
                            {/* <div className="task_btn_area">
                                <CustomTab
                                    tabs={tabs}
                                    currentTab={currentTab}
                                    setCurrentTab={(e) => setCurrentTab(e)}
                                />
                            </div> */}
                            <div className="tab_details">
                                {/* <div className={parseInt(currentTab) === 1 ? 'sorting_data' : 'd-none'}>
                                    <div className="left_area">
                                        <p>Assigned Task</p>
                                    </div>
                                    <div className="right_area">
                                        <div className="sort_button">
                                            <Button className="btn-primary" type="submit"> Sort <Image src={Filter} alt="..." className="image_area" /> </Button>
                                        </div>
                                    </div>
                                </div> */}
                                <div className="date_num_area">
                                    <div className="left_date_area">
                                        <Button className="btnm primary" onClick={() => setShowCalendarModal(true)}>
                                            <div className="icon">
                                                <Image src={LogCalendar} alt="..." className="image_area" />
                                            </div>
                                        </Button>
                                        {
                                            showCalendarModal ? (
                                                <CalendarModal show={showCalendarModal} close={() => setShowCalendarModal(false)} />
                                            ) : null
                                        }
                                        <p>13 Aug 2023</p>
                                        {/* <div className="button_area">
                                            <Button className="btnm primary" onClick={() => setShowCalendarModal(true)}>13 Aug 2023</Button>
                                            {
                                                showCalendarModal ? (
                                                    <CalendarModal show={showCalendarModal} close={() => setShowCalendarModal(false)} />
                                                ) : null
                                            }
                                        </div> */}
                                        {/* <p><FontAwesomeIcon icon={faCalendarMinus} className="date_icon" />13 Aug 2023</p> */}
                                    </div>
                                    <a href="javascript:;">
                                        <div className="right_num_area">
                                            <Button className="btnm primary" onClick={() => setShowFilterModal(true)}>
                                                <Image src={Filter} alt="..." className="image_area" />
                                            </Button>
                                        </div>
                                    </a>
                                </div>
                                {/* Custom_DatePicker */}
                                <CustomDatepicker />
                                <div className="custom_tab_data">
                                    {parseInt(currentTab) === 1 ? <Task /> : null}
                                    {/* {parseInt(currentTab) === 2 ? <Reports /> : null}
                                    {parseInt(currentTab) === 3 ? <Lab /> : null} */}

                                </div>
                                <div className="pagination_space">
                                    <PaginationComponent />
                                </div>
                                <div className="assign_task">
                                    <a href="AssignTask">
                                        <div className="circle_area">
                                            <div className="add_icon_area">
                                                <FontAwesomeIcon icon={faPlus} />
                                                <p>Assign Task</p>
                                            </div>
                                        </div>
                                    </a>
                                </div>

                            </div>

                        </div>
                    </Col>
                </Row>
            </Container>
            {
                showFilterModal ? (
                    <FilterModal show={showFilterModal} close={() => setShowFilterModal(false)} />
                ) : null
            }
        </div>
    );
};

export default MyTasks;
